import React from 'react';

import Image from '../../../../library/image/image';

import styles from './studdable-image.scss';

function StuddableImage() {
  return (
    <Image
      alt="Studdable"
      className={styles['studdable-image']}
      height="24"
      src="https://discounttire.scene7.com/is/content/discounttire/logos/icons/feature-icon_studdable-tire.svg"
      width="24"
    />
  );
}

export default StuddableImage;
